module.exports = "<div class=\"left-elements\">\n    <app-name-label></app-name-label>\n</div>\n<div class=\"right-elements\" ng-transclude></div>\n"